module.exports = __webpack_public_path__ + "static/network6-04776ab344505a96cf7da6548533d87b.jpg";